import { Button } from '@eo/shared';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';

import { checkedLabel } from './helpers';
import type { IntegrationCardProps } from './types';

export function IntegrationCard({ descriptor, status, onManage }: IntegrationCardProps) {
  const checked = checkedLabel(status.verifiedAt);

  return (
    <section className="flex flex-col gap-4 rounded-16 border border-border-faint p-6">
      <div className="flex flex-col gap-1">
        <h2 className="text-xl text-text-primary">{descriptor.title}</h2>
        <p className="text-sm text-text-tertiary">{descriptor.purpose}</p>
      </div>

      <div className="flex flex-col gap-1">
        <span className="flex items-center gap-2 text-sm text-text-primary">
          {status.problem ? (
            <AlertTriangle className="size-4 shrink-0 text-destructive" aria-hidden="true" />
          ) : (
            <CheckCircle2 className="size-4 shrink-0 text-success" aria-hidden="true" />
          )}
          <span className="truncate">
            Connected
            {(status.account ?? status.detail) ? ` · ${status.account ?? status.detail}` : ''}
          </span>
        </span>
        {status.problem && <p className="text-xs text-destructive">{status.problem}</p>}
        {status.lastNote && <p className="text-xs text-text-tertiary">{status.lastNote}</p>}
        {checked && <p className="text-xs text-text-tertiary">{checked}</p>}
      </div>

      <Button
        variant="secondary"
        className="w-fit"
        onClick={onManage}
        aria-label={`Manage ${descriptor.title}`}
      >
        Manage
      </Button>
    </section>
  );
}
